var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 31.5,
    viewBox: "0 0 24 31.5",
    fill: "#39abf2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M21,31.5H3a3,3,0,0,1-3-3v-15a3,3,0,0,1,3-3H4.5v-3a7.5,7.5,0,1,1,15,0v3H21a3,3,0,0,1,3,3v15A3,3,0,0,1,21,31.5ZM3,13.5v15H21v-15ZM12,3A4.505,4.505,0,0,0,7.5,7.5v3h9v-3A4.505,4.505,0,0,0,12,3Zm0,21a3,3,0,1,1,3-3A3,3,0,0,1,12,24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPadlock);
export default __webpack_public_path__ + "static/media/icon-padlock.20bef928307e78b259b538458a01c0db.svg";
export { ForwardRef as ReactComponent };